var map = {
	"./NoCurrencySupport.gif": 9553,
	"./badGateway.gif": 6093,
	"./gatewayTimeout.gif": 4019,
	"./genServerErr.gif": 8948,
	"./paymentFailed.gif": 7606,
	"./requestTimeOut.gif": 8900,
	"./serviceUnavailable.gif": 5883,
	"./transLimitExceeded.gif": 3202
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2132;